/**
 * Created by staffanrantzow on 09/11/16.
 */

import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import SupplierLedgerModal from './supplier-ledger-modal';
import { ToolTip } from 'components';
import { proxyCounterpart } from '../../../../scripts/proxyCounterpart';

class SupplierLedger extends React.Component {
  static propTypes = {
    supplierLedger: PropTypes.array.isRequired,
    setSupplierLedger: PropTypes.func.isRequired,
    currencyName: PropTypes.string.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      showModal: false
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal (e) {
    if (e) e.preventDefault();
    this.setState({
      showModal: !this.state.showModal
    });
  }

  renderModal () {
    if (this.state.showModal) return <SupplierLedgerModal close={this.toggleModal}/>;
  }

  button (translate = 'ADD_DEDUCTION') {
    return (<b>
      <a onClick={this.toggleModal}>
        + <Translate content={translate} />
      </a>
    </b>);
  }

  renderButton () {
    if (!this.props.supplierLedger.length) return this.button();
    return this.button('EDIT_DEDUCTION');
  }

  render () {
    return (<div className='details-row'>
      <div className='details-left'>
        {this.renderButton()}
        <ToolTip id='deduction' msg={proxyCounterpart('TOOLTIP_DEDUCTION')}/>
      </div>
      {this.renderModal()}
    </div>);
  }
}

export default SupplierLedger;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/supplier-ledger/supplier-ledger.js
 **/